module.exports = __webpack_public_path__ + "img/Quadrobee.05a71355.svg";